import formatSeo from './format-seo.json'

export default class {
  constructor(content) {
    this.id = content.id
    this.title = content.title
    this.description = content.description
    // SEO 文言は format-seo.json が正本（ビルド時の prerender-formats.js も同じ JSON を読む）。
    // エントリの無い書式は undefined のままで、従来どおり title / description から組み立てる。
    const seo = formatSeo[content.id] || {}
    this.seoTitle = seo.title
    this.seoDescription = seo.description
    this.h1Title = seo.h1
    this.thumbnail = content.thumbnail
    this.images = content.images
    this.newdetail1 = content.newdetail1
    this.newdetail2 = content.newdetail2
    this.newdetail3 = content.newdetail3
    this.newdetail = content.newdetail
    this.pagenumbs = content.pagenumbs
    this.requiredBasicFields = content.requiredBasicFields || ['all']
    this.hashs = content.hashs || []
    this.components = content.components || {}
    this.cards = content.cards || []
    this.sampleData = content.sampleData || {}
    this.exampleSentences = content.exampleSentences || {}
    this.formatDataType = content.formatDataType
  }
}
